import { submitForm } from 'actions';
import { preferencesService } from 'constants';

export default (formName, resourcePath, userGuid, body, callerOptions = {}) =>
  submitForm(
    formName,
    `${preferencesService.baseUrl}/${resourcePath}`,
    userGuid,
    body,
    callerOptions,
  );
